import Request from "./index";

class Api {
  // 获取学校前台导航子应用菜单列表
  static getNavigationList(data) {
    return Request.get("/base/navigation_list", {
      params: data
    });
  }

  // 获取学校前台子应用路由列表
  static getSubappRouteList(data) {
    return Request.get("/base/subapp_route_list", {
      params: data
    });
  }

  // 获取学校前台个人空间子应用列表
  static getSpaceNavigationList(data) {
    return Request.get("/base/space_navigation_list", {
      params: data
    });
  }

  // 获取学校前台个人空间子应用列表
  static getSubappRegisterList(data) {
    return Request.get("/base/subapp_register_list", {
      params: data
    });
  }

  // 获取底部机构网站信息
  static getInformationList(data) {
    return Request.get("/base/org/information", {
      params: data
    });
  }

  // 获取轮播图列表
  static getLunboList(data) {
    return Request.get("/base/information/slideshow", {
      params: {
        id: data.area_id,
        area_type: data.area_type
      }
    });
  }

  // 通过访问网址获取机构信息
  static getOrgDetailByPathname(web_path) {
    return Request.get("/base/org/org_detail", {
      params: {
        web_path
      }
    });
  }

  // 获取所有通知公告列表
  static getAllNotice(school_id) {
    return Request.get("/base/notice/list/all", {
      params: {
        school_id
      }
    });
  }

  // 获取通知公告列表（分页）
  static getNoticePage(data) {
    return Request.get("/base/notice/list/page", {
      params: data
    });
  }

  // 查看通知公告详情
  static getNoticeDetail(id) {
    return Request.get("/base/notice/detail/" + id);
  }

  //【前台】提交留言/意见反馈
  static commitMessage(data) {
    return Request.post("/base/leave_message", data);
  }

  // 获取微信二维码
  static getWeixinCode(data) {
    return Request.get("/auth/wechat/qrcode", {
      params: data
    });
  }

  // 微信扫码登录
  static getWeChatScan(data) {
    return Request.get("/auth/login/wechat_scan", {
      params: data
    });
  }
  // 获取点播剩余流量
  static getVideoFluxFree(school_id) {
    return Request.get(`/operate/school_manage/is_video_flux_free?school_id=${school_id}`);
  }
  // 获取直播剩余流量
  static getLiveFluxFree(school_id) {
    return Request.get(`/operate/school_manage/is_live_flux_free?school_id=${school_id}`);
  }

  // 获取学校设置信息
  static getSchoolSetting(id) {
    return Request.get("/base/school/setting/" + id);
  }

  // 退出登录
  static loginOut() {
    return Request.get("/auth/login/out");
  }

  // 验证页面权限
  static verifyPagePermisson(data) {
    return Request.get("/auth/user_verify_page_permisson", {
      params: data
    });
  }

  // 获取平台字典列表
  static getPlatformDictionaryList() {
    return Request.get("/base/platform_dictionary/list");
  }

  // 获取平台网页是否置灰
  static getSetGray(data) {
    return Request.get("/base/platform/set_gray", {
      params: data
    });
  }
}

export default Api;
